// WalletConnect Project ID
// Get one from https://cloud.walletconnect.com
export const WALLETCONNECT_PROJECT_ID = "df9eb73ffe200f2adf28bacf5f9f4793";

// Supported chains for devnet wallet connection
export const SUPPORTED_CHAIN_IDS = [
  1, // Ethereum Mainnet
  11155111, // Sepolia
  42161, // Arbitrum One
  421614, // Arbitrum Sepolia
  8453, // Base
  84532, // Base Sepolia
];
